/* Denvale custom behaviour. No dependencies. Transform/opacity/filter only; respects reduced motion.
   Works alongside Dawn's product-form.js (AJAX add to cart) and pubsub.js (cartUpdate / cartError events). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function money(cents) {
    var fmt = window.hwMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDec = (cents / 100).toFixed(0);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/<[^>]+>/g, '');
  }

  function announce(text) {
    var live = document.getElementById('hw-live');
    if (!live) { live = document.createElement('div'); live.id = 'hw-live'; live.className = 'hw-live'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }

  /* ---------- scroll reveal (three-beat heads, once-only cards) ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) e.classList.add('is-in'); else io.observe(e);
    });
  }

  /* ---------- anatomy hotspots ----------
     The numbered list is the keyboard path (5 tab stops); the hotspots on the photo are pointer shortcuts with
     tabindex="-1". Click / tap / Enter selects a part; focus alone only draws the outline, it previews nothing. */
  function initAnatomy(root) {
    (root || document).querySelectorAll('[data-hw-anatomy]').forEach(function (sec) {
      var spots = sec.querySelectorAll('.hw-hotspot');
      var items = sec.querySelectorAll('.hw-anatomy__item');
      function activate(key, touched) {
        spots.forEach(function (s) { s.setAttribute('aria-pressed', s.dataset.key === key ? 'true' : 'false'); });
        items.forEach(function (i) {
          var on = i.dataset.key === key;
          i.classList.toggle('is-active', on);
          /* same word for the same state on both surfaces: the hotspot and the list button both report aria-pressed */
          i.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (touched) sec.classList.add('is-touched');
        var item = sec.querySelector('.hw-anatomy__item[data-key="' + key + '"] b');
        if (touched && item) announce(item.textContent);
      }
      spots.forEach(function (s) { s.addEventListener('click', function () { activate(s.dataset.key, true); if (window.innerWidth < 990) { var t = sec.querySelector('.hw-anatomy__item[data-key="' + s.dataset.key + '"]'); if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } }); });
      items.forEach(function (i) { i.addEventListener('click', function () { activate(i.dataset.key, true); }); });
      if (items[0]) activate(items[0].dataset.key, false);
    });
  }

  /* ---------- heat level selector ----------
     A radiogroup with roving tabindex: one tab stop, arrows / Home / End move and select, Space and Enter select
     (the chips are buttons, so the browser does that). The reading cross-fades, it never counts through values.
     The section's lamp pool follows the level through --hw-room; it sits behind the content and never touches the photo. */
  function initHeat(root) {
    (root || document).querySelectorAll('[data-hw-heat]').forEach(function (box) {
      if (box.dataset.hwReady) return;
      /* Chips are found by container, not by [role="radio"]: markup cached from before this deploy (bfcache, a CDN
         copy, a stale Section Rendering response) carries no roles, and it should still get click handlers rather
         than a permanently dead demo. hwReady is only stamped once chips were actually found, so a box that could
         not be wired is retried on the next init instead of being marked done. */
      var chips = [].slice.call(box.querySelectorAll('.hw-heat__levels button'));
      if (!chips.length) return;
      box.dataset.hwReady = '1';
      var min = parseFloat(box.dataset.min), max = parseFloat(box.dataset.max);
      if (isNaN(min)) min = 82;
      if (isNaN(max)) max = 115;
      var labels = (box.dataset.labels || 'Gentle|Mild|Warm|Cozy|Hot|Toasty').split('|');
      var group = box.querySelector('[role="radiogroup"]') || box.querySelector('.hw-heat__levels');
      var reading = box.querySelector('[data-reading]'), old = box.querySelector('[data-reading-old]');
      var label = box.querySelector('[data-label]'), sec = box.closest('.hw-section');
      var n = chips.length, current = -1;
      /* the chip carries the temperature Liquid already printed in its label, so JS and the markup can never disagree */
      function tempAt(i) {
        var t = parseFloat(chips[i].dataset.temp);
        return isNaN(t) ? Math.round(min + (max - min) * (n > 1 ? i / (n - 1) : 0)) : t;
      }
      function swapReading(t) {
        if (!reading || !reading.firstChild) return;
        if (reduce || current < 0 || !old || !old.firstChild) { reading.firstChild.nodeValue = t; return; }
        old.firstChild.nodeValue = reading.firstChild.nodeValue;
        reading.firstChild.nodeValue = t;
        box.classList.remove('is-swapping');
        void box.offsetWidth; /* restart the 150ms cross-fade */
        box.classList.add('is-swapping');
      }
      function set(i) {
        if (i === current) return;
        chips.forEach(function (c, j) {
          c.setAttribute('aria-checked', j === i ? 'true' : 'false');
          c.tabIndex = j === i ? 0 : -1;
          c.classList.toggle('is-below', j < i);
        });
        swapReading(tempAt(i));
        if (label) label.textContent = labels[i] || '';
        if (sec) {
          if (current >= 0) sec.setAttribute('data-room', i > current ? 'warming' : 'cooling');
          sec.style.setProperty('--hw-room', (0.6 + 0.4 * (n > 1 ? i / (n - 1) : 1)).toFixed(3));
        }
        current = i;
      }
      chips.forEach(function (c, i) { c.addEventListener('click', function () { set(i); }); });
      if (group) group.addEventListener('keydown', function (e) {
        var from = chips.indexOf(e.target);
        if (from < 0) from = current;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = Math.min(n - 1, from + 1);
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = Math.max(0, from - 1);
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next === null) return;
        e.preventDefault();
        set(next);
        chips[next].focus();
      });
      var start = chips.findIndex ? chips.findIndex(function (c) { return c.getAttribute('aria-checked') === 'true'; }) : -1;
      set(start >= 0 ? start : Math.min(3, n - 1));
    });
  }

  /* ---------- disclosure panels with animated open/close ---------- */
  function initPanels(root) {
    (root || document).querySelectorAll('details[data-hw-panel]').forEach(function (d) {
      var summary = d.querySelector('summary'), acc = d.querySelector('.hw-acc');
      if (!summary || !acc || d.dataset.hwPanelReady) return;
      d.dataset.hwPanelReady = '1';
      if (d.open) d.classList.add('is-open');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduce) { d.open = !d.open; d.classList.toggle('is-open', d.open); return; }
        if (d.classList.contains('is-open')) {
          d.classList.remove('is-open');
          var done = function (ev) { if (ev.propertyName === 'grid-template-rows') { d.open = false; acc.removeEventListener('transitionend', done); } };
          acc.addEventListener('transitionend', done);
          setTimeout(function () { if (!d.classList.contains('is-open')) d.open = false; }, 420);
        } else {
          d.open = true;
          raf(function () { raf(function () { d.classList.add('is-open'); }); });
        }
      });
    });
  }

  /* ---------- day carousel dots (mobile) ---------- */
  function initDay(root) {
    (root || document).querySelectorAll('[data-hw-day]').forEach(function (sec) {
      var track = sec.querySelector('.hw-day__track'), dots = sec.querySelector('.hw-day__dots');
      if (!track || !dots) return;
      var cards = track.querySelectorAll('.hw-moment');
      dots.innerHTML = '';
      cards.forEach(function (c, i) { var d = document.createElement('i'); if (i === 0) d.className = 'on'; dots.appendChild(d); });
      var ds = dots.querySelectorAll('i'), pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return; pending = true;
        raf(function () {
          pending = false;
          var idx = Math.round(track.scrollLeft / (cards[0].offsetWidth + 12));
          ds.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
        });
      }, { passive: true });
    });
  }

  /* ---------- buy box ---------- */
  function initBuy(root) {
    (root || document).querySelectorAll('[data-hw-buy]').forEach(function (box) {
      var dataEl = box.querySelector('script[data-hw-variants]');
      if (!dataEl || box.dataset.hwReady) return;
      box.dataset.hwReady = '1';
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = box.querySelector('input[name="id"]');
      var qtyInput = box.querySelector('input[name="quantity"]');
      var priceEl = box.querySelector('[data-hw-price]');
      var compareEl = box.querySelector('[data-hw-compare]');
      var totalEl = box.querySelector('[data-hw-total]');
      var colorOut = box.querySelector('[data-hw-color-name]');
      var mainImg = box.querySelector('[data-hw-main]');
      var submit = box.querySelector('.product-form__submit');
      var submitText = submit ? (submit.querySelector('[data-hw-atc-label]') || submit.querySelector('span')) : null;
      var addText = submit ? submit.dataset.add : 'Add to cart';
      var soldText = submit ? submit.dataset.soldout : 'Sold out';
      var current = null;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var off = 0;
      var firstBundle = box.querySelector('.hw-bundle[aria-checked="true"]');
      if (firstBundle) off = parseInt(firstBundle.dataset.off, 10) || 0;
      /* bundle price = unit price x qty minus a fixed amount (cents) that matches an automatic discount in Shopify */
      function bundleTotal(price, q, o) { return Math.max(0, price * q - (o || 0)); }
      function bundleEach(price, q, o) { return Math.round(bundleTotal(price, q, o) / q); }

      function byId(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }

      function swapImage(src, srcset, alt) {
        if (!mainImg || !src || mainImg.getAttribute('src') === src) return;
        var apply = function () { mainImg.src = src; if (srcset) mainImg.srcset = srcset; if (alt) mainImg.alt = alt; if (mainImg.parentElement) mainImg.parentElement.classList.toggle('is-heating', /hw-flat-pink/.test(src)); };
        if (reduce) { apply(); return; }
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          apply();
          mainImg.classList.remove('is-blooming'); void mainImg.offsetWidth; mainImg.classList.add('is-blooming');
        };
        pre.src = src;
      }

      function render(fromUser) {
        if (!current) return;
        if (idInput) idInput.value = current.id;
        if (priceEl) priceEl.textContent = money(current.price);
        if (compareEl) {
          if (current.compare_at_price && current.compare_at_price > current.price) { compareEl.textContent = money(current.compare_at_price); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (totalEl) totalEl.textContent = money(bundleTotal(current.price, qty, off));
        var kit = box.querySelector('.hw-kit'), kitTotal = box.querySelector('[data-kit-total]'), kitCompare = box.querySelector('[data-kit-compare]'), kitBadge = box.querySelector('[data-kit-badge]'), kitNote = box.querySelector('[data-kit-note]');
        if (kitTotal) {
          var selB = box.querySelector('.hw-bundle[aria-checked="true"]'), free = selB ? (parseInt(selB.dataset.free, 10) || 0) : 0;
          /* launch price: compare against the real post-launch regular price until the launch ends, then against today's price */
          var regular = kit ? (parseInt(kit.dataset.launchRegular, 10) || 0) : 0;
          var ends = kit && kit.dataset.launchEnds ? Date.parse(kit.dataset.launchEnds) : NaN;
          var launchOn = regular > current.price && !isNaN(ends) && Date.now() < ends;
          var tot = bundleTotal(current.price, qty, off), base = (launchOn ? regular : current.price) * qty, save = base - tot;
          kitTotal.textContent = money(tot);
          if (kitCompare) { kitCompare.textContent = money(base); kitCompare.hidden = save <= 0; }
          if (kitBadge) { kitBadge.textContent = (free > 0 ? free + ' Free — ' : '') + 'Save ' + Math.round(save * 100 / base) + '%'; kitBadge.hidden = save <= 0; }
          if (kitNote) kitNote.hidden = !launchOn;
          if (launchOn && !box.dataset.hwLaunchTimer && ends - Date.now() < 86400000) { box.dataset.hwLaunchTimer = '1'; setTimeout(function () { render(false); }, ends - Date.now() + 1000); }
        }
        box.querySelectorAll('.hw-bundle').forEach(function (b) {
          var q = parseInt(b.dataset.qty, 10) || 1, o = parseInt(b.dataset.off, 10) || 0;
          var t = b.querySelector('[data-bundle-total]'), e = b.querySelector('[data-bundle-each]'), c = b.querySelector('[data-bundle-compare]'), g = b.querySelector('[data-bundle-tag]');
          if (t) t.textContent = money(bundleTotal(current.price, q, o));
          if (e) e.textContent = money(bundleEach(current.price, q, o)) + ' each';
          if (c) { c.textContent = money(current.price * q); c.setAttribute('aria-label', 'Regular price ' + money(current.price * q)); }
          if (g && current.price > 0) g.textContent = 'Save ' + Math.round(o * 100 / (current.price * q)) + '%';
        });
        if (colorOut) colorOut.textContent = current.title;
        if (submit && !submit.classList.contains('is-adding') && !submit.classList.contains('is-added')) {
          var ok = current.available;
          submit.toggleAttribute('disabled', !ok);
          if (submitText) submitText.textContent = ok ? addText : soldText;
        }
        box.querySelectorAll('[data-hw-swatch], .hw-swatch').forEach(function (s) { s.setAttribute('aria-checked', String(s.dataset.variantId) === String(current.id) ? 'true' : 'false'); });
        /* the page opens on the first gallery image; the photo only follows the colour once the shopper picks one */
        if (fromUser && current.featured_image && current.featured_image.src) {
          var base = current.featured_image.src.split('?')[0];
          swapImage(base + '?width=1000', base + '?width=600 600w, ' + base + '?width=1000 1000w, ' + base + '?width=1400 1400w', current.featured_image.alt || current.title);
          var mini = box.querySelector('[data-hw-mini]'); if (mini) mini.src = base + '?width=160';
          var baseName = base.split('/').pop();
          box.querySelectorAll('.hw-buy__thumbs button').forEach(function (t) { t.setAttribute('aria-current', (t.dataset.src || '').split('/').pop().split('?')[0] === baseName ? 'true' : 'false'); });
        }
        var url = new URL(window.location.href);
        if (fromUser && (url.searchParams.has('variant') || box.dataset.updateUrl === 'true')) { url.searchParams.set('variant', current.id); history.replaceState({}, '', url); }
        if (fromUser) announce(current.title + ', ' + money(current.price) + (qty > 1 ? ', total ' + money(bundleTotal(current.price, qty, off)) : '') + (current.available ? '' : ', sold out'));
        document.dispatchEvent(new CustomEvent('hw:variant', { detail: { variant: current, qty: qty, total: bundleTotal(current.price, qty, off) } }));
      }

      box.querySelectorAll('[data-hw-swatch], .hw-swatch').forEach(function (s) {
        s.addEventListener('click', function () { var v = byId(s.dataset.variantId); if (v) { current = v; render(true); } });
      });
      box.querySelectorAll('.hw-bundle').forEach(function (b) {
        b.addEventListener('click', function () {
          qty = parseInt(b.dataset.qty, 10) || 1;
          off = parseInt(b.dataset.off, 10) || 0;
          if (qtyInput) qtyInput.value = qty;
          box.querySelectorAll('.hw-bundle').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
          render(true);
        });
      });
      box.querySelectorAll('.hw-buy__thumbs button').forEach(function (t) {
        t.addEventListener('click', function () {
          var base = t.dataset.src;
          swapImage(base + '?width=1000', base + '?width=600 600w, ' + base + '?width=1000 1000w, ' + base + '?width=1400 1400w', t.dataset.alt || '');
          box.querySelectorAll('.hw-buy__thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        });
      });

      var strip = box.querySelector('[data-hw-thumbs]');
      var prevBtn = box.querySelector('[data-hw-thumbs-prev]'), nextBtn = box.querySelector('[data-hw-thumbs-next]');
      function scrollStrip(dir) { if (!strip) return; strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollStrip(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollStrip(1); });

      /* add-to-cart states: adding -> added (Dawn does the request; we listen to its pub/sub events) */
      var form = box.querySelector('form[data-type="add-to-cart-form"]');
      var stickyBtn = document.querySelector('[data-hw-sticky-add]');
      var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:1.8rem;height:1.8rem"><path d="M20 6 9 17l-5-5"/></svg>';
      function setState(state) {
        [submit, stickyBtn].forEach(function (b) {
          if (!b) return;
          var span = b.querySelector('[data-hw-atc-label]') || b.querySelector('span') || b;
          b.classList.remove('is-adding', 'is-added');
          if (state === 'adding') { b.classList.add('is-adding'); span.innerHTML = b.dataset.adding || 'Adding…'; }
          else if (state === 'added') { b.classList.add('is-added'); span.innerHTML = CHECK + (b.dataset.added || 'Added to cart'); }
          else { span.textContent = b.dataset.add || addText; }
        });
      }
      if (form) form.addEventListener('submit', function () { setState('adding'); announce('Adding to cart'); });
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source !== 'product-form') return;
          setState('added'); announce('Added to cart');
          var icon = document.getElementById('cart-icon-bubble');
          if (icon && !reduce) { icon.classList.remove('hw-cart-bump'); void icon.offsetWidth; icon.classList.add('hw-cart-bump'); }
          setTimeout(function () { setState('idle'); render(false); }, 1600);
        });
        subscribe(PUB_SUB_EVENTS.cartError, function () { setState('idle'); render(false); });
      } else {
        // fallback: watch Dawn's .loading class
        if (submit && 'MutationObserver' in window) new MutationObserver(function () { if (!submit.classList.contains('loading') && submit.classList.contains('is-adding')) { setState('added'); setTimeout(function () { setState('idle'); render(false); }, 1600); } }).observe(submit, { attributes: true, attributeFilter: ['class'] });
      }

      current = byId(idInput && idInput.value) || variants.filter(function (v) { return v.available; })[0] || variants[0];
      render(false);
    });
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-hw-sticky]');
    if (!bar || bar.dataset.hwReady) return;
    bar.dataset.hwReady = '1';
    var buy = document.querySelector('[data-hw-buy]') || document.querySelector('.product-form');
    var hero = document.querySelector('.hw-hero');
    var buyVisible = false, pastTop = false;
    function update() {
      var drawerOpen = document.body.classList.contains('hw-drawer-open');
      bar.classList.toggle('is-visible', pastTop && !buyVisible && !drawerOpen);
    }
    if ('IntersectionObserver' in window) {
      if (buy) new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; update(); }, { threshold: 0.12 }).observe(buy);
      if (hero) new IntersectionObserver(function (en) { pastTop = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }, { threshold: 0 }).observe(hero);
    }
    if (!hero) {
      var t = false;
      window.addEventListener('scroll', function () { if (t) return; t = true; raf(function () { t = false; pastTop = window.scrollY > 420; update(); }); }, { passive: true });
    }
    // hide while the cart drawer / menu drawer is open
    var drawer = document.querySelector('cart-drawer');
    var menu = document.querySelector('header-drawer details');
    function syncDrawer() {
      var open = (drawer && drawer.classList.contains('active')) || (menu && menu.hasAttribute('open'));
      document.body.classList.toggle('hw-drawer-open', !!open); update();
    }
    if ('MutationObserver' in window) {
      if (drawer) new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (menu) new MutationObserver(syncDrawer).observe(menu, { attributes: true, attributeFilter: ['open'] });
    }
    var btn = bar.querySelector('[data-hw-sticky-add]');
    if (btn) btn.addEventListener('click', function (e) {
      var form = buy && buy.querySelector('form[data-type="add-to-cart-form"]');
      if (form && typeof form.requestSubmit === 'function') { e.preventDefault(); form.requestSubmit(); }
      else if (form) { e.preventDefault(); form.submit(); }
    });
    document.addEventListener('hw:variant', function (ev) {
      var p = bar.querySelector('[data-hw-sticky-price]'), t = bar.querySelector('[data-hw-sticky-variant]');
      var total = ev.detail.total != null ? ev.detail.total : ev.detail.variant.price * ev.detail.qty;
      if (p) p.textContent = money(total);
      if (t) t.textContent = ev.detail.variant.title + (ev.detail.qty > 1 ? ' × ' + ev.detail.qty : '');
      /* the crossed-out price follows the same basket: regular price x quantity, so it can never read as the
         per-robe price next to a bundle total. Save % is recomputed from the two numbers on screen. */
      var wrap = bar.querySelector('[data-launch-regular]');
      if (!wrap) return;
      var regular = parseInt(wrap.getAttribute('data-launch-regular'), 10) || 0;
      var base = regular * (ev.detail.qty || 1);
      var was = wrap.querySelector('[data-hw-sticky-was]'), save = wrap.querySelector('[data-hw-sticky-save]');
      if (was && base > total) was.lastChild.nodeValue = money(base);
      if (save && base > total) save.textContent = 'Save ' + Math.round((base - total) * 100 / base) + '%';
    });
  }

  /* ---------- ship-today countdown (real daily cutoff in the warehouse time zone) ---------- */
  function initCutoff(root) {
    (root || document).querySelectorAll('[data-hw-cutoff]').forEach(function (el) {
      if (el.dataset.hwReady) return;
      el.dataset.hwReady = '1';
      var hour = parseFloat(el.dataset.hour); if (isNaN(hour)) hour = 12;
      var tz = el.dataset.tz || 'America/New_York';
      var weekdaysOnly = el.dataset.weekdays !== 'false';
      var closed = (el.dataset.closed || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var tail = el.dataset.tail || 'to ship [day]';
      var hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
      var tailEl = el.querySelector('[data-tail-text]'), sr = el.querySelector('[data-cutoff-sr]'), lead = el.querySelector('.hw-cutoff__lead');
      var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var fmt;
      try { fmt = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) { return; }
      function key(y, mo, d, add) { return new Date(Date.UTC(y, mo - 1, d + add)).toISOString().slice(0, 10); }
      function open(dow, k) { return (!weekdaysOnly || (dow >= 1 && dow <= 5)) && closed.indexOf(k) === -1; }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      var lastMin = -1;
      function tick() {
        var p = {};
        fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        var y = +p.year, mo = +p.month, d = +p.day, dow = WD[p.weekday];
        var now = (+p.hour % 24) * 3600 + (+p.minute) * 60 + (+p.second), cut = Math.round(hour * 3600);
        var add = 0, left;
        if (open(dow, key(y, mo, d, 0)) && now < cut) {
          left = cut - now;
        } else {
          add = 1;
          while (add < 15 && !open((dow + add) % 7, key(y, mo, d, add))) add++;
          left = (86400 - now) + (add - 1) * 86400 + cut;
        }
        var day = add === 0 ? 'today' : add === 1 ? 'tomorrow' : DAYS[(dow + add) % 7];
        var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
        var tailText = tail.replace('[day]', day);
        if (tailEl) tailEl.textContent = tailText;
        if (sr && m !== lastMin) { lastMin = m; sr.textContent = (lead ? lead.textContent : 'Order within') + ' ' + h + ' hours ' + m + ' minutes ' + tailText; }
      }
      tick();
      el.hidden = false;
      var offer = el.closest('.hw-offer'); if (offer) offer.classList.add('has-cutoff');
      setInterval(tick, 1000);
    });
  }

  /* ---------- launch price (hero): hide the crossed-out price, Save % and note once the launch ends ---------- */
  function initLaunch(root) {
    (root || document).querySelectorAll('[data-hw-launch]').forEach(function (el) {
      var ends = Date.parse(el.getAttribute('data-launch-ends') || '');
      function check() {
        var on = !isNaN(ends) && Date.now() < ends;
        el.querySelectorAll('[data-launch-el]').forEach(function (x) { x.hidden = !on; });
      }
      check();
      var left = ends - Date.now();
      if (!isNaN(ends) && left > 0 && left < 86400000 && !el.dataset.hwLaunchTimer) { el.dataset.hwLaunchTimer = '1'; setTimeout(check, left + 1000); }
    });
  }

  /* ---------- chat launcher arrival ----------
     The Shopify Inbox launcher sits over the phone headline on load. .hw-chat-wait on <html> holds it at
     opacity 0 / pointer-events none until the visitor has scrolled past ~60% of the first screen, or 6
     seconds have passed — whichever comes first, so someone who never scrolls still gets it. Nothing here
     touches the <shopify-chat> element, so it is harmless on pages where the app never loads. */
  function initChat() {
    var root = document.documentElement;
    if (root.dataset.hwChat) return;
    root.dataset.hwChat = '1';
    root.classList.add('hw-chat-wait');
    var timer = null;
    function reveal() {
      root.classList.remove('hw-chat-wait');
      window.removeEventListener('scroll', onScroll);
      if (timer) clearTimeout(timer);
      timer = null;
    }
    function onScroll() {
      if (window.pageYOffset > window.innerHeight * 0.6) reveal();
    }
    timer = setTimeout(reveal, 6000);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); /* deep link / restored scroll position: show it straight away */
  }

  /* ---------- reviews: count the score and the review total up once, when the summary card arrives ---------- */
  function initReviewsCount(root) {
    (root || document).querySelectorAll('.hw-reviews__summary:not([data-counted])').forEach(function (sum) {
      sum.setAttribute('data-counted', '1');
      if (reduce || !('IntersectionObserver' in window)) return;
      var score = sum.querySelector('.hw-reviews__score');
      var scoreNode = score && score.firstChild;
      var target = scoreNode && parseFloat(scoreNode.nodeValue);
      if (!target) return;
      var count = sum.querySelector('.hw-reviews__count');
      var countText = count ? count.textContent : '';
      var m = countText.match(/\d+/);
      var countTarget = m ? parseInt(m[0], 10) : 0;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 900;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          scoreNode.nodeValue = (target * e).toFixed(1);
          if (count && countTarget) count.textContent = countText.replace(m[0], String(Math.round(countTarget * e)));
          if (p < 1) requestAnimationFrame(step);
          else { scoreNode.nodeValue = target.toFixed(1); if (count) count.textContent = countText; }
        }
        requestAnimationFrame(step);
      }, { threshold: 0.4 });
      io.observe(sum);
    });
  }

  function initAll(root) { initReveal(root); initAnatomy(root); initHeat(root); initPanels(root); initDay(root); initBuy(root); initCutoff(root); initLaunch(root); initReviewsCount(root); }

  /* runs before DOMContentLoaded so the launcher is held back before the Inbox embed paints it. It is guarded
     because it is the only statement ahead of the init wiring below: a throw here would leave the whole page
     without reveals, the heat demo, the anatomy list and the sticky bar. */
  try { initChat(); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); });
  else { initAll(); initSticky(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initSticky(); });
})();
